import { render } from "./ViewTemaTemporario.vue?vue&type=template&id=932621f0&scoped=true"
import script from "./ViewTemaTemporario.vue?vue&type=script&lang=js"
export * from "./ViewTemaTemporario.vue?vue&type=script&lang=js"

import "./ViewTemaTemporario.vue?vue&type=style&index=0&id=932621f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-932621f0"]])

export default __exports__